import React,{useState} from 'react';
import '../CSS/projectCard.scss';
import {motion, AnimatePresence} from 'framer-motion'
import Overlay from './Overlay';
import ProjectModal from './ProjectModal';
import {textVariantLeft, textVariantRight, lineAnim, cardVariant} from '../Variants/variants'

const ProjectCard = ({project, previewGif, previewHover}) =>{
    const [open, setOpen] = useState(false);
    const [hover, setHover] = useState(false);

    const openModal = () => {
        setOpen(true);
    }

    const closeModal = () => {
        setOpen(false);
    }

    const HoverDetails = () =>{
        return(
            <motion.div className="project-details" >
                <motion.div>
                    <motion.h2 
                    className="project-title" 
                    variants={ previewHover && hover ? textVariantLeft : ""}
                    initial={ previewHover && hover ? "initial" : ""}
                    animate={ previewHover && hover ? "animate" : ""}
                    exit={ previewHover && hover ? "initial" : ""}
                    >{project.title}</motion.h2>
                    <motion.div 
                    className='line' 
                    variants={ previewHover && hover ? lineAnim : ""}
                    initial={ previewHover && hover ? "initial" : ""}
                    animate={ previewHover && hover ? "animate" : ""}
                    exit={ previewHover && hover ? "initial" : ""}
                    ></motion.div>
                </motion.div>
                <motion.p
                variants={ previewHover && hover ? textVariantLeft : ""}
                initial={ previewHover && hover ? "initial" : ""}
                animate={ previewHover && hover ? "animate" : ""}
                exit={ previewHover && hover ? "initial" : ""}>
                    {project.previewDesc}
                </motion.p>
                <motion.div 
                className="project-tech-container right"
                variants={ previewHover && hover ? textVariantRight : ""}
                initial={ previewHover && hover ? "initial" : ""}
                animate={ previewHover && hover ? "animate" : ""}
                exit={ previewHover && hover ? "initial" : ""}>
                    {project.tech.map((tech, index) => {
                        return(
                            <span key={index} className="project-tech">{tech}</span>
                        )
                    })}
                </motion.div>
            </motion.div>
        )
    }

    return(
        <>
            <motion.div className="project-card-container" layout="position"
            variants={cardVariant}
            initial="initial"
            animate="animate"
            exit="initial"
            onClick={openModal}
            key={project.title} onMouseOver={() => setHover(true)} onMouseLeave={() => setHover(false)}
            >
                <motion.div className="project-card-img">
                    {!previewHover && (
                        <motion.img 
                        initial={{opacity: .2}}
                        transition={{type: "tween"}}
                        whileHover={{scale: 1.1}} 
                        src={hover ? (previewGif ? project.gifImg : project.mainImg) : project.mainImg} 
                        className="project-img"/>
                    )}
                    {previewHover &&(
                        <motion.img 
                        transition={{type: "tween"}}
                        whileHover={{scale: 1.1, opacity: .2}} 
                        src={hover ? (previewGif ? project.gifImg : project.mainImg) : project.mainImg} 
                        className="project-img"/>
                    )}
                </motion.div>
                    {(!previewHover && (
                        <HoverDetails/>
                    ))}
                    <AnimatePresence>
                        {previewHover && hover && (
                            <HoverDetails/>
                        )}
                    </AnimatePresence>
            </motion.div>
            <AnimatePresence>
                {open && (
                    <Overlay closeModal={closeModal}>
                        <ProjectModal project={project} closeModal={closeModal}/>
                    </Overlay>
                )}
            </AnimatePresence>
        </>
    )
}

export default ProjectCard;